import PeopleView from "../views/PeopleView.vue";
import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
    {
        path: "/",
        name: "people",
        component: PeopleView,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;
